import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemoveFileExtensionPipe } from './remove-file-extension.pipe';
import { DatetimePipe } from './datetime.pipe';

const Modules = [
  RemoveFileExtensionPipe,
  DatetimePipe
]

@NgModule({
  declarations: [...Modules],
  imports: [
    CommonModule
  ],
  exports: [...Modules]
})
export class PipesModule { }
